import { CTCreditCardData } from 'shared/types/creditCard/CreditCard';
import MasonCredit from '@/components/customercenter-ui/svgs/masonCredit';
import MasonEasyPay from '@/components/customercenter-ui/svgs/masonEasyPay';
import StoneBerryCredit from '@/components/customercenter-ui/svgs/stoneBerry';
import { mapLocaleToMeaningfulFormat } from '@/helpers/utils/i18n';
import { cardRegex } from '../../../constants/constant';
import AmericanExpress from '../icons/americanExpress';
import Discover from '../icons/discover';
import MasterCardIcon from '../icons/masterCard';
import VisaIcon from '../icons/visa';

const AMEX_CARD_TYPE = mapLocaleToMeaningfulFormat().amex;

export function getCardType(cardNumber: string) {
  const cleanedCardNumber = cardNumber?.replace(/\D/g, '');

  for (const [type, regex] of Object.entries(cardRegex)) {
    if (regex.test(cleanedCardNumber)) {
      return type;
    }
  }
  return 'unknown';
}

export const getMaxlengthCreditCard = (cardType: string): number => {
  return cardType === AMEX_CARD_TYPE ? 18 : 19;
};

export const formatExpiryDate = (expDate: string): string => {
  let formattedValue = expDate.replace(/\D/g, '');
  if (formattedValue.length === 1 && parseInt(formattedValue) > 1) {
    formattedValue = '0' + formattedValue;
  } else if (formattedValue.length === 2 && parseInt(formattedValue) > 12) {
    formattedValue = '12';
  }
  return formattedValue.slice(0, 2) + (formattedValue.length > 2 ? '/' + formattedValue.slice(2) : '');
};

export const isCardExpired = (card: CTCreditCardData) => {
  let isCardExpired = false;
  if (card?.expirationYear && card?.expirationMonth) {
    const expirationYear = parseInt(card.expirationYear);
    const expirationMonth = parseInt(card.expirationMonth);
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth() + 1;
    if (currentYear > expirationYear || (currentYear === expirationYear && currentMonth > expirationMonth)) {
      isCardExpired = true;
    }
  }
  return isCardExpired;
};

export const getCardIcon = (creditCardType: string) => {
  switch (creditCardType?.toLowerCase()) {
    case 'visa':
      return <VisaIcon className="h-10 w-16" />;
    case 'mastercard':
      return <MasterCardIcon className="h-12 w-16" />;
    case 'discover':
      return <Discover className="h-10 w-16" />;
    case 'amex':
      return <AmericanExpress className="h-12 w-16" />;
    case 'americanexpress':
      return <AmericanExpress className="h-12 w-16" />;
    default:
      return null;
  }
};

export const getDivisionSvgs = (division: string, className: string) => {
  switch (division) {
    case 'ZY':
      return <MasonCredit />;
    case 'ZB':
      return <StoneBerryCredit />;
    case 'SM':
      return <></>;
    case 'MQ':
      return <></>;
    case 'ZD':
      return <MasonEasyPay className={className} />;
    default:
      return <></>;
  }
};
